import {Component, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AbstractControl, UntypedFormGroup} from '@angular/forms';
import {ProfileFormService} from '../profile-form.service';
import {ScreenService} from 'src/app/ui-library/screen.service';

@Component({
    selector: 'app-setup-recipient-profile-details',
    templateUrl: './setup-recipient-profile-details.component.html',
    styleUrls: ['./setup-recipient-profile-details.component.scss'],
    standalone: false
})
export class SetupRecipientProfileDetailsComponent implements OnInit, OnDestroy {
    readonly form: UntypedFormGroup;
    readonly step2: UntypedFormGroup;
    isTrapActive = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private renderer: Renderer2,
        private screenService: ScreenService,
        formService: ProfileFormService) {
        this.isTrapActive = this.screenService.isMobileScreen();
        this.form = formService.createRecipient();
        this.step2 = this.form.get('step2') as UntypedFormGroup;
    }

    get authorizedToSign(): AbstractControl {
        return this.step2.get('authorizedToSign');
    }

    get navigateState() {
        return {
            onboardingForm: this.form.value
        };
    }

    ngOnInit(): void {
        // add class to body to prevent scrolling in the background on mobile screen
        this.renderer.addClass(document.body, 'full-screen');

        const formState = window.history.state?.onboardingForm;
        if (formState) {
            this.form.setValue(formState);
        } else {
            this.router.navigate(['../recipient-profile'], {
                relativeTo: this.route
            });
        }
    }

    ngOnDestroy(): void {
        this.renderer.removeClass(document.body, 'full-screen');
    }

    back(): void {
        // the user is not allowed to navigate back while uploading
        const docControl = this.step2.controls.documents;
        if (docControl.invalid) {
            docControl.markAsTouched();
            return;
        }

        this.router.navigate(['../recipient-profile'], {
            relativeTo: this.route,
            state: this.navigateState
        });
    }

    next(): void {
        if (!this.step2.valid) {
            this.step2.markAllAsTouched();
            return;
        }

        this.router.navigate(['../recipient-offer'], {
            relativeTo: this.route,
            state: this.navigateState
        });
    }
}
